import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { LaneInput } from '@kinetic-ui/data-layer';
import { useTranslation } from 'react-i18next';
import { LaneForm } from './LaneForm';
import useLaneStyles from './styles';
import { Alert, Box } from '@mui/material';
import { useSelectedLane } from './selectedLaneState';
import { RecursivePartial } from 'types';
import { useFormViewStyles } from 'components/forms';
import ContentHeader from 'components/ContentHeader';

type LaneListProps = {
  lanes: RecursivePartial<LaneInput>[];
  title: string;
};

export function LaneList({ lanes, title }: LaneListProps) {
  const classes = useLaneStyles();
  const formViewClasses = useFormViewStyles();
  const { t } = useTranslation('locations');
  const { selectedLane, setSelectedLane } = useSelectedLane();

  return (
    <div className={classes.laneList}>
      {lanes.length === 0 ? (
        <Alert severity='warning'>{t('emptyLocationObjectMessage', { object: title })}</Alert>
      ) : (
        <ContentHeader
          id={`header_${title}`}
          variant='body1'
          component='section'
          className={formViewClasses.title}
        >
          {title}
        </ContentHeader>
      )}
      <Box className={classes.laneAccordion}>
        {lanes.map((lane) => (
          <Accordion
            expanded={selectedLane?.id === lane.id}
            key={lane.id}
            onChange={(_, expanded) => setSelectedLane(expanded ? lane : undefined)}
            TransitionProps={{ unmountOnExit: true }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>{lane.description}</AccordionSummary>
            <AccordionDetails>
              {selectedLane?.id === lane.id && (
                <LaneForm currentLane={lane} onClose={() => setSelectedLane(undefined)} />
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </div>
  );
}
